import { AgreementPersonalDataProcessingDocument } from "../../components/Documents/AgreementPersonalDataProcesssingDocument";
import { LoginLayout } from "../../layouts/LoginLayout/LoginLayout";
import React from "react";
export const PageAgreementDataProcessingDocument = () => {
  return (
    <LoginLayout classNameMain="classNameMainRegCenter">
      <AgreementPersonalDataProcessingDocument />
    </LoginLayout>
  );
};
